import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommercePerformanceReportOrdersLastYearEntityState} from "../reducers/ecommerce-performance-report-order-last-year.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommercePerformanceReportOrdersLastYearState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommercePerformanceReportOrdersLastYear.entities[websiteId]);

export const getEcommercePerformanceReportOrdersLastYear = (websiteId: number) => createSelector(getEcommercePerformanceReportOrdersLastYearState(websiteId),
  (state: IEcommercePerformanceReportOrdersLastYearEntityState) => {
      return state.ordersDataLastYear;
  }
);

export const getEcommercePerformanceReportOrdersLastYearLoading = (websiteId: number) => createSelector(getEcommercePerformanceReportOrdersLastYearState(websiteId),
  (state: IEcommercePerformanceReportOrdersLastYearEntityState) => state && state.loading
);

export const getEcommercePerformanceReportOrdersLastYearLoaded = (websiteId: number) => createSelector(getEcommercePerformanceReportOrdersLastYearState(websiteId),
  (state: IEcommercePerformanceReportOrdersLastYearEntityState) => state && state.loaded
);
